var Voucher = "https://shopfront-cdn.tekoapis.com/static/071b0994e39e244d.svg";

export { Voucher as default };
